import { render, staticRenderFns } from "./ChartWidget.vue?vue&type=template&id=2c09c2ca&"
import script from "./ChartWidget.vue?vue&type=script&lang=js&"
export * from "./ChartWidget.vue?vue&type=script&lang=js&"
import style0 from "./ChartWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports